// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"605d1155","977":"c4755d00"}[chunkId] + ".chunk.js";
};